var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAk231280(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 87.7 30",
    style: {
      enableBackground: "new 0 0 87.7 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 59.8,
    y: 7,
    transform: "matrix(0.8832 -0.469 0.469 0.8832 5.1054 35.6281)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 7.1,
    transform: "matrix(0.4972 -0.8676 0.8676 0.4972 18.635 74.8246)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.4,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.1,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7,30H57.5V0h30.2V30z M58.7,28.8h27.9V1.2H58.7V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7,25.9H60.9V3.7h22.8V25.9z M62.1,24.8h20.5V4.8H62.1V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: -6.7,
    transform: "matrix(0.4694 -0.883 0.883 0.4694 0.5398 16.0246)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.4,
    y: 20.8,
    transform: "matrix(0.8676 -0.4973 0.4973 0.8676 -8.7798 9.6963)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2,30H0V0h30.2V30z M1.2,28.8H29V1.2H1.2V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8,25.9H4V3.7h22.8V25.9z M5.1,24.8h20.5V4.8H5.1V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.8,
    y: -6.7,
    transform: "matrix(0.4694 -0.883 0.883 0.4694 15.7965 41.414)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.3,
    y: 20.8,
    transform: "matrix(0.8676 -0.4973 0.4973 0.8676 -4.973 23.9927)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9,30H28.8V0h30.2V30z M29.9,28.8h27.9V1.2H29.9V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5,25.9H32.7V3.7h22.8V25.9z M33.9,24.8h20.5V4.8H33.9V24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7,30c-0.2,0-0.4-0.1-0.5-0.3L85.4,28c-0.1-0.3,0-0.6,0.3-0.8c0.3-0.1,0.6,0,0.8,0.3l0.7,1.6c0.1,0.3,0,0.6-0.3,0.8 L86.7,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9,25.9c-0.2,0-0.4-0.1-0.5-0.3l-1.4-3.3c-0.1-0.3,0-0.6,0.3-0.8c0.3-0.1,0.6,0,0.8,0.3l1.4,3.3c0.1,0.3,0,0.6-0.3,0.8 L84.9,25.9z M82.3,20.2c-0.2,0-0.4-0.1-0.5-0.3l-1.4-3.3c-0.1-0.3,0-0.6,0.3-0.8c0.3-0.1,0.6,0,0.8,0.3l1.4,3.3 c0.1,0.3,0,0.6-0.3,0.8L82.3,20.2z M79.8,14.5c-0.2,0-0.4-0.1-0.5-0.3l-1.4-3.3c-0.1-0.3,0-0.6,0.3-0.8c0.3-0.1,0.6,0,0.8,0.3 l1.4,3.3c0.1,0.3,0,0.6-0.3,0.8L79.8,14.5z M77.3,8.8c-0.2,0-0.4-0.1-0.5-0.3l-1.4-3.3c-0.1-0.3,0-0.6,0.3-0.8 c0.3-0.1,0.6,0,0.8,0.3L77.8,8c0.1,0.3,0,0.6-0.3,0.8L77.3,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8,3.1c-0.2,0-0.4-0.1-0.5-0.3l-0.7-1.6c-0.1-0.3,0-0.6,0.3-0.8c0.3-0.1,0.6,0,0.8,0.3l0.7,1.6c0.1,0.3,0,0.6-0.3,0.8 L74.8,3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8,30l-0.3-0.1c-0.3-0.1-0.4-0.5-0.2-0.8L60,26c0.1-0.3,0.5-0.4,0.8-0.2c0.3,0.1,0.4,0.5,0.2,0.8l-1.7,3.2 C59.2,29.9,59,30,58.8,30z M61.8,24.5l-0.3-0.1c-0.3-0.1-0.4-0.5-0.2-0.8l1.7-3.2c0.1-0.3,0.5-0.4,0.8-0.2c0.3,0.1,0.4,0.5,0.2,0.8 l-1.7,3.2C62.2,24.4,62,24.5,61.8,24.5z M64.7,19l-0.3-0.1c-0.3-0.1-0.4-0.5-0.2-0.8l1.7-3.2c0.2-0.3,0.5-0.4,0.8-0.2 c0.3,0.1,0.4,0.5,0.2,0.8l-1.7,3.2C65.1,18.8,64.9,19,64.7,19z M67.7,13.4l-0.3-0.1c-0.3-0.1-0.4-0.5-0.2-0.8l1.7-3.2 C69,9.1,69.4,9,69.6,9.2c0.3,0.1,0.4,0.5,0.2,0.8l-1.7,3.2C68.1,13.3,67.9,13.4,67.7,13.4z M70.6,7.9l-0.3-0.1 c-0.3-0.1-0.4-0.5-0.2-0.8l1.7-3.2c0.2-0.3,0.5-0.4,0.8-0.2c0.3,0.1,0.4,0.5,0.2,0.8l-1.7,3.2C71,7.8,70.8,7.9,70.6,7.9z M73.6,2.4 l-0.3-0.1c-0.3-0.1-0.4-0.5-0.2-0.8l0.5-0.9c0.1-0.3,0.5-0.4,0.8-0.2c0.3,0.1,0.4,0.5,0.2,0.8l-0.5,0.9C74,2.3,73.8,2.4,73.6,2.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAk231280);
export default __webpack_public_path__ + "static/media/AK2_3_128_0.2c650cd346b9dac1f33e8753b6a71c81.svg";
export { ForwardRef as ReactComponent };